import apiClient from "./api-client";
import { cobeeLog } from "./log";

export function getRequestContext(req) {
  return `${req.method} ${req.path}`;
}

export function logRequest(req) {
  cobeeLog({
    type: "request",
    context: getRequestContext(req),
    payload: req.payload,
    level: "info",
  });
}

export function logResponse(req, res) {
  cobeeLog({
    type: "response",
    context: getRequestContext(req),
    payload: {
      statusCode: res.statusCode,
    },
    level: "info",
  });
}
export function logRouteException(req, exception) {
  cobeeLog({
    type: "response",
    context: getRequestContext(req),
    exception,
    level: "error",
  });
}

export async function handleRoute(req) {
  try {
    logRequest(req);
    const res = await apiClient()[req.method](req.path, req.payload);
    logResponse(req, res);
    return res;
  } catch (exception) {
    logRouteException(req, exception);
    throw exception;
  }
}
